import React from "react";
import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

export function IdiomaSelector({ claro = false, className = "" }) {
  const { idioma, setIdioma } = useT();
  return (
    <div
      role="group"
      aria-label="Language / Idioma"
      data-testid="idioma-selector"
      className={cn(
        "inline-flex items-center rounded-full border p-0.5 text-[12.5px] font-display font-bold tracking-[.06em]",
        claro ? "border-white/30 bg-white/10" : "border-line bg-surface",
        className
      )}
    >
      {["en", "es"].map((i) => {
        const activo = idioma === i;
        return (
          <button
            key={i}
            type="button"
            data-testid={`idioma-${i}`}
            aria-pressed={activo}
            onClick={() => setIdioma(i)}
            className={cn(
              "min-w-[40px] h-7 px-2.5 rounded-full transition-colors duration-150",
              activo ? (claro ? "bg-white text-navy" : "bg-navy text-white") : claro ? "text-white/80 hover:text-white" : "text-ink-3 hover:text-ink"
            )}
          >
            {i.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
